module.exports = __webpack_public_path__ + "static/media/plus.875ee86e.svg";